import PropTypes from 'prop-types';
import React, { useState } from 'react';
import ArcButton from '../ArcButton/arcButton';
import { ArcButtonGroupContextProvider } from '../../utils/buttonContext';
import groupStyle from './groupButton.module.scss';


function GroupButton(props) {
  const {
    options,
    value,
    style,
    unit,
  } = props;
  const [val, setVal] = useState(value);

  const onButtonChange = (e) => {
    setVal(e);
    const { onChange } = props;
    if (e !== val) {
      onChange(e);
    }
  };

  const renderGroup = () => options.map((item, index) => (
    <ArcButton
      key={item.key}
      id={item.key}
      text={item.text}
      checked={val === item.key}
      style={style}
      unit={unit}
      isSpacing={index !== (options.length - 1)}
    >
      {item}
    </ArcButton>
  ));

  return (
    <ArcButtonGroupContextProvider value={{ onChange: onButtonChange }}>
      <div className={groupStyle['arc-group-button']}>
        {renderGroup()}
      </div>
    </ArcButtonGroupContextProvider>
  );
}

GroupButton.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func,
  unit: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  style: PropTypes.objectOf(PropTypes.any),
};

GroupButton.defaultProps = {
  options: [], // 按钮文案数组
  onChange: () => {}, // 点击当前按钮事件
  value: '', // 绑定的值
  style: {},
  unit: 'rem',
};

export default GroupButton;
